import { format, parseISO, setDefaultOptions } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { UTCDate } from '@date-fns/utc'
import { cpf, cnpj } from 'cpf-cnpj-validator'
import { removeNonNumeric, sanitizeCnpj } from './string'

setDefaultOptions({ locale: ptBR })

export const formatCPF = (cpf: string) =>
  cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')

export const formatCNPJ = (value: string) => {
  const cleaned = sanitizeCnpj(value)
  return cleaned.replace(
    /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
    '$1.$2.$3/$4-$5',
  )
}

export const maskCpf = (taxId: string | null | undefined) => {
  const digits = (taxId ?? '').replace(/\D/g, '')
  if (digits.length !== 11) return null

  return `***.${digits.slice(3, 6)}.${digits.slice(6, 9)}-**`
}

export const formatTaxId = (taxId: string) => {
  const sanitizedCnpj = sanitizeCnpj(taxId)
  const digitsOnly = removeNonNumeric(taxId)

  if (sanitizedCnpj.length === 14) {
    return cnpj.format(sanitizedCnpj)
  }

  if (digitsOnly.length === 11) {
    return cpf.format(digitsOnly)
  }

  return taxId
}

export const formatDate = (
  date: string | number | Date,
  formatStr: string = 'P',
) => format(new UTCDate(date), formatStr)

export const parseISOtoDate = (isoDate: string) =>
  parseISO(isoDate.slice(0, 10))

export const formatPercentage = (value: number) =>
  value.toLocaleString('pt-BR', {
    style: 'percent',
    maximumFractionDigits: 2,
  })
